export var DEFAULT_TOOLTIP_CLASSNAMES = {
    appear: "rmd-tooltip--enter",
    appearActive: "rmd-tooltip--visible",
    enter: "rmd-tooltip--enter",
    enterActive: "rmd-tooltip--visible",
    enterDone: "rmd-tooltip--visible",
    exit: "rmd-tooltip--visible rmd-tooltip--exit",
    exitActive: "rmd-tooltip--exit-active",
};
export var DEFAULT_TOOLTIP_TIMEOUT = {
    enter: 200,
    exit: 150,
};
export var DEFAULT_TOOLTIP_DELAY = 1000;
export var DEFAULT_TOOLTIP_THRESHOLD = 0.75;
//# sourceMappingURL=constants.js.map